/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Activation_Missing_Machine_Id_ErrorInputs */



/**
* | output |
* | --- |
* | "Please enter a machine id." |
*
* @param {Offline_Activation_Missing_Machine_Id_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_activation_missing_machine_id_error = /** @type {((inputs?: Offline_Activation_Missing_Machine_Id_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Activation_Missing_Machine_Id_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez entrer un identifiant de machine.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte geben Sie eine Maschinen-ID ein.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci un ID macchina.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, введите идентификатор машины.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ingrese un ID de máquina.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请输入机器ID。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マシンIDを入力してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया मशीन आईडी दर्ज करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, insira um ID de máquina.")
	return /** @type {LocalizedString} */ ("Please enter a machine id.")
});